<template>
    <div>
        <v-stepper vertical v-model="step" class="px-md-10 px-0">

            <v-stepper-step step="1">
                مرحله ۱
                <small>نوع سفارش</small>
            </v-stepper-step>
            <v-stepper-content class="mx-0 px-1 pr-2" step="1">
                <h5 class="pb-5 text-center"> {{ pageTitle }}</h5>
                <div class="m-3">
                    <v-text-field outlined
                                  dense
                                  v-model="data.organizationName"
                                  hint="لطفا نام مجموعه خود را وارد کنید."
                                  maxLength="50"
                                  counter="50"
                                  :rules="this.$rules.requiredString"
                                  label="نام مجموعه "
                                  append-icon="mdi-domain"/>
                </div>
                <div class="m-3">
                    <v-text-field outlined
                                  dense
                                  v-model="data.brandName"
                                  hint="لطفا نام برند خود را  وارد  کنید."
                                  maxLength="50"
                                  counter="50"
                                  :rules="this.$rules.requiredString"
                                  label="نام برند "
                                  append-icon="mdi-domain"/>
                </div>
                <div class="m-3">
                    <v-text-field outlined
                                  v-model="data.brandSlogan"
                                  dense
                                  hint="لطفا شعار برند خود را وارد نمایید"
                                  placeholder="لطفا شعار برند خود را وارد نمایید"
                                  maxLength="50"
                                  counter="50"
                                  label="شعار برند"
                                  append-icon="mdi-domain"/>
                </div>
                <div class="m-3 text-right">
                    <v-switch
                            v-model="data.slogan"
                            dense
                            class="text-right"
                            :label="data.type!=='logo'?'میخواهم شعار در تراکت اضافه شود':'میخواهم شعار در لوگو اضافه شود'"
                    ></v-switch>
                </div>

                <v-btn class="submit-btn" @click="step1Validate">
                    ادامه
                    <span class="fa fa-arrow-left mr-1"></span>
                </v-btn>
            </v-stepper-content>

            <v-stepper-step step="2">
                مرحله ۲
                <small>اطلاعات اولیه سفارش</small>
            </v-stepper-step>
            <v-stepper-content class="mx-0 px-1 pr-2" step="2">
                <div class="mt-2">
                    <div>
                        <v-expansion-panels class="px-1">
                            <v-expansion-panel
                                    class="mb-4 px-1 customStyle"
                                    v-if="data.type==='logo'">
                                <v-expansion-panel-header disable-icon-rotate class="px-1">
                                    نوع طراحی لوگو را مشخص نمایید.
                                    <div v-if="data.logoType && !isMobile">
                                        <v-chip
                                                v-if="data.logoType"
                                                close-icon="mdi-close-outline"
                                                color="indigo"
                                                small
                                                class="mx-2"
                                                outlined
                                        >{{ names["logoType"] }}
                                        </v-chip>
                                    </div>
                                    <template v-slot:actions>
                                        <v-icon v-if="data.logoType && isMobile" color="teal">mdi-check</v-icon>
                                    </template>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <logo-type class="mb-4" v-if="data.type==='logo'" @persianName="persianName"
                                               v-model="data.logoType"></logo-type>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel
                                    class="mb-4 px-1 customStyle"
                                    v-if="data.type==='tracet' || data.type==='visit_card' "
                            >
                                <v-expansion-panel-header disable-icon-rotate class="px-1">
                                    {{
                                        data.type === 'tracet' ? '  لطفا زبان طراحی تراکت خود را انتخاب نمایید.' : '  لطفا زبان طراحی لوگو را انتخاب نمایید'
                                    }}
                                    <div v-if="data.logoLanguage && !isMobile">
                                        <v-chip
                                                v-if="data.logoLanguage"
                                                close-icon="mdi-close-outline"
                                                color="indigo"
                                                small
                                                class="mx-2"
                                                outlined
                                        >{{ names["langType"] }}
                                        </v-chip>
                                    </div>
                                    <template v-slot:actions>
                                        <v-icon v-if="data.logoLanguage && isMobile" color="teal">mdi-check</v-icon>
                                    </template>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <lang-type @persianName="persianName" class="mb-4"
                                               v-model="data.logoLanguage"
                                               v-if="data.type==='tracet' || data.type==='visit_card' "></lang-type>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel class="mb-4 px-1 customStyle"
                                               v-if="data.type==='tracet' || data.type==='visit_card'">
                                <v-expansion-panel-header disable-icon-rotate class="px-1">
                                    لطفا رنگ تراکت خود را انتخاب نمایید.
                                    <div v-if="data.color.length>0 && colorCount!=='bw' && !isMobile">
                                        <v-chip
                                                v-if="data.color.length>0"
                                                v-for="color in data.color"
                                                close-icon="mdi-close-outline"
                                                color="indigo"
                                                small
                                                :color="color"
                                                class="mx-2"
                                                outlined
                                                dense
                                        >{{ color }}
                                        </v-chip>
                                    </div>
                                    <template v-slot:actions>
                                        <v-icon v-if="data.color.length>0 && isMobile" color="teal">mdi-check</v-icon>
                                    </template>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-container
                                            class="px-0"
                                            fluid
                                    >
                                        <v-radio-group v-model="colorCount">
                                            <v-radio
                                                    label="تک رنگ"
                                                    value="one"
                                            ></v-radio>
                                            <v-radio
                                                    label="چهار رنگ"
                                                    value="four"
                                            ></v-radio>
                                            <v-radio
                                                    label="سیاه سفید"
                                                    value="bw"
                                            ></v-radio>
                                        </v-radio-group>
                                    </v-container>
                                    <color-pickers :count="colorCount==='four'? '3' : '0' " v-model="data.color"
                                                   class="mb-4"
                                                   v-if="data.type==='tracet' && colorCount!=='bw'"></color-pickers>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </div>
                    <div>
                        <v-expansion-panels class="px-1">
                            <v-expansion-panel
                                    class="mb-4 px-1 customStyle"
                                    v-if="data.type==='tracet'"
                            >
                                <v-expansion-panel-header disable-icon-rotate class="px-1">
                                    لطفا نوع سفارش و طرح خودرا انتخاب کنید.
                                    <div class="row mr-2" v-if="!isMobile">
                                        <div v-if="data.orderType">
                                            <v-chip
                                                    v-if="data.orderType"
                                                    close-icon="mdi-close-outline"
                                                    color="indigo"
                                                    small
                                                    class="mx-2"
                                                    outlined
                                            >{{ orderType.find((x) => x.value === data.orderType).text }}
                                            </v-chip>
                                        </div>
                                        <div v-if="data.orderType==='designPrint' && data.printCount">
                                            <v-chip
                                                    v-if="data.printCount"
                                                    close-icon="mdi-close-outline"
                                                    color="indigo"
                                                    small
                                                    class="mx-2"
                                                    outlined
                                            >{{ data.printCount|currency|persianNum }} عدد
                                            </v-chip>
                                        </div>
                                        <div v-if="data.size">
                                            <v-chip
                                                    v-if="data.size"
                                                    close-icon="mdi-close-outline"
                                                    color="indigo"
                                                    small
                                                    class="mx-2"
                                                    outlined
                                            >{{ data.size }}
                                            </v-chip>
                                        </div>
                                        <div v-if="data.designStyle">
                                            <v-chip
                                                    v-if="data.designStyle"
                                                    close-icon="mdi-close-outline"
                                                    color="indigo"
                                                    small
                                                    class="mx-2"
                                                    outlined
                                            >{{ tracetType.find((x) => x.value === data.designStyle).text }}
                                            </v-chip>
                                        </div>
                                    </div>
                                    <template v-slot:actions>
                                        <v-icon v-if="data.orderType && data.size && isMobile" color="teal">mdi-check
                                        </v-icon>
                                    </template>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-autocomplete
                                            v-if="data.type==='tracet' && others"
                                            class="m-1"
                                            v-model="data.size"
                                            :items="sizeTracet"
                                            dense
                                            item-text="text"
                                            item-value="value"
                                            label="سایز تراکت"
                                            placeholder="لطفا سایز تراکت خود را مشخص نمایید."
                                            hint="لطفا یک گزینه را انتخاب نمایید."
                                            outlined
                                    >
                                        <template v-slot:prepend-item>
                                            <v-list-item
                                                    ripple
                                                    @mousedown.prevent
                                                    @click="others = false"
                                            >
                                                <v-list-item-action>
                                                    <p>واردکردن سایز تراکت دلخواه</p>
                                                </v-list-item-action>
                                            </v-list-item>
                                        </template>
                                    </v-autocomplete>
                                    <v-text-field
                                            v-if="!others"
                                            label="سایز تراکت دلخواه"
                                            hint="لطفا سایز درخواستی خود را انتخاب یا وارد نمایید."
                                            placeholder="لطفا سایز درخواستی خود را انتخاب یا وارد نمایید."
                                            dense
                                            v-model="data.size"
                                            outlined
                                            prepend-inner-icon="fa fa-pencil-alt"
                                            clear-icon="mdi-close-circle-outline"
                                            clearable
                                            @click:clear="others=true;data.size=null"
                                    ></v-text-field>
                                    <v-autocomplete
                                            v-if="data.type==='tracet'"
                                            class="m-1"
                                            v-model="data.orderType"
                                            :items="orderType"
                                            dense
                                            item-text="text"
                                            item-value="value"
                                            label="نوع سفارش"
                                            placeholder="لطفا یک گزینه را انتخاب نمایید."
                                            hint="لطفا یک گزینه را انتخاب نمایید."
                                            outlined
                                    ></v-autocomplete>
                                    <v-autocomplete
                                            v-if="data.orderType==='designPrint'"
                                            class="m-1"
                                            v-model="data.designStyle"
                                            :items="tracetType"
                                            dense
                                            clearable
                                            clear-icon="mdi-close-circle-outline"
                                            item-text="text"
                                            item-value="value"
                                            label="نوع تراکت"
                                            placeholder="لطفا یک گزینه را انتخاب نمایید."
                                            hint="لطفا یک گزینه را انتخاب نمایید."
                                            outlined
                                    ></v-autocomplete>
                                    <v-text-field
                                            v-if="data.type==='tracet' && data.orderType==='designPrint'"
                                            class="m-1"
                                            v-model="printCounting"
                                            dense
                                            clearable
                                            clear-icon="mdi-close-circle-outline"
                                            item-text="text"
                                            @keypress="allowOnlyNumbers"
                                            item-value="value"
                                            label="تعداد چاپ"
                                            placeholder="تعداد وارد شده با مضربی از 1000 محاسبه می شود."
                                            hint="تعداد وارد شده با مضربی از 1000 محاسبه می شود."
                                            outlined
                                    ></v-text-field>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel
                                    class="mb-4 px-1 customStyle"
                                    v-if="data.type==='tracet'"
                            >
                                <v-expansion-panel-header disable-icon-rotate class="px-1">
                                    لطفا نوع طرح تراکت را انتخاب نمایید.
                                    <div v-if="data.designType && !isMobile">
                                        <v-chip
                                                v-if="data.designType"
                                                close-icon="mdi-close-outline"
                                                color="indigo"
                                                small
                                                class="mx-2"
                                                outlined
                                        >{{ names["trSabk"] }}
                                        </v-chip>
                                    </div>
                                    <template v-slot:actions>
                                        <v-icon v-if="data.designType && isMobile" color="teal">mdi-check</v-icon>
                                    </template>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <tracet-sabk @persianName="persianName" v-model="data.designType"
                                                 class="mb-4"></tracet-sabk>

                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </div>
                </div>
                <div class="row justify-content-between py-2 mx-auto">
                    <v-btn class="submit-btn col-md-1 col-3" @click="step2Validate">
                        ادامه
                        <span class="fa fa-arrow-left mr-1"></span>
                    </v-btn>
                    <v-btn class="mx-4 btn-refund col-md-1 col-3" @click="step = 1">
                        <span class="fa fa-arrow-right mr-1"></span>
                        بازگشت
                    </v-btn>
                </div>
            </v-stepper-content>

            <v-stepper-step step="3">
                مرحله ۳
                <small>مشخصات سایت</small>
            </v-stepper-step>
            <v-stepper-content class="mx-0 px-1 pr-2" step="3">
                <div class="mt-2" v-if="step===3">
                    <programming-select class="mt-5" v-if="data.type==='logo'"
                                        v-model="data.logo_size"></programming-select>
                    <div v-if="data.type==='tracet'" class="">
                        <span class="text-center pb-2">لطفا یک یا چند تراکت مورد علاقه خود را برای ما ارسال کنید. تا تیم طراحی ما، نیاز شما را بهتر درک کنند.</span>
                    </div>
                    <v-file-input
                            v-model="data.file"
                            label=" بارگذاری عکس "
                            outlined
                            accept="image/png, image/jpeg,image/jpg, image/bmp"
                            placeholder="عکس موردنظر خود را بارگذاری کنید."
                            hint="حداکثر حجم هر عکس مورد نظر می‌تواند 1 مگابابت باشد."
                            prepend-inner-icon="mdi-camera"
                            clearable
                            small-chips
                            multiple
                            clear-icon="mdi-close-circle-outline"
                            prepend-icon=""
                            dense
                            class="mt-1 pt-1"
                    >
                    </v-file-input>
                    <div class="m-3" v-if="data.type==='tracet'">
                        <span class="text-center pb-2">لطفا لوگو برند خودرابارگذاری کنید</span>
                    </div>
                    <v-file-input
                            v-if="data.type==='tracet'"
                            v-model="data.brandLogo"
                            label=" بارگذاری عکس "
                            outlined
                            accept="image/png,image/jpeg"
                            placeholder="لطفا لوگو برند خودرابارگذاری کنید."
                            hint="حداکثر حجم هر عکس مورد نظر می‌تواند 1 مگابابت باشد."
                            prepend-inner-icon="mdi-camera"
                            clearable
                            multiple
                            small-chips
                            clear-icon="mdi-close-circle-outline"
                            prepend-icon=""
                            dense
                            class="mt-1 mx-3 pt-1"
                    >
                    </v-file-input>
                </div>

                <div class="row justify-content-between py-2 mx-auto">
                    <v-btn class="submit-btn col-md-1 col-3" @click="step3Validate">
                        ادامه
                        <span class="fa fa-arrow-left mr-1"></span>
                    </v-btn>
                    <v-btn class="mx-4 btn-refund col-md-1 col-3" @click="step = 2">
                        <span class="fa fa-arrow-right mr-1"></span>
                        بازگشت
                    </v-btn>
                </div>
            </v-stepper-content>

            <v-stepper-step step="4">
                مرحله ۴
                <small>زمان تحویل</small>
            </v-stepper-step>
            <v-stepper-content class="mx-0 px-1 pr-2" step="4">

                <div class="mx-3">
                    <date-picker
                            v-model="data.deliveryTime"
                            color="#00acc1"
                            label="زمان تحویل"
                            input-class="mb-0 rounded"
                            persianDigits
                            clearable
                            :timezone="false"
                            format="YYYY-MM-DD"
                            style="font-size: 13px!important"
                            class="dateSet"
                            display-format="jMMMM jD"
                            :min="countDay"
                    />
                </div>
                <div class="m-3" v-if="data.type==='tracet'">
                    <p class="mt-10 pb-2">لطفا متون ومندرجات روی تراکت خود را تایپ کنید.</p>
                    <V8Editor v-model="data.headerTexts"/>
                </div>
                <div class="m-3" v-if="data.type==='tracet' && data.designType==='twoSide'">
                    <p class="mt-10 pb-2">لطفا متون ومندرجات پشت تراکت خود را تایپ کنید.</p>
                    <V8Editor v-model="data.backText"/>
                </div>
                <div class="m-3">
                    <v-text-field outlined
                                  dense
                                  class="pt-5"
                                  v-model="data.businessDescription"
                                  hint="لطفا درمورد حوزه کسب وکارخود توضیح دهید."
                                  maxLength="50"
                                  counter="50"
                                  :rules="this.$rules.requiredString"
                                  label="حوزه کسب وکار "
                                  append-icon="mdi-domain"/>
                </div>
                <div class="row justify-content-between py-2 mx-auto">
                    <v-btn class="submit-btn col-md-1 col-3 mt-5" @click="step4Validate">
                        <span class="fa fa-arrow-left mr-1"></span>
                        ادامه
                    </v-btn>
                    <v-btn class="mx-4 mt-5 btn-refund col-md-1 col-3" @click="step = 3">
                        <span class="fa fa-arrow-right mr-1"></span>
                        بازگشت
                    </v-btn>
                </div>
            </v-stepper-content>


            <v-stepper-step step="5">
                مرحله ۵
                <small>توضیحات</small>
            </v-stepper-step>
            <v-stepper-content class="mx-0 px-1 pr-2" step="5">
                <div class="mt-1">
                    <div class="mb-2">
                        <span class="text-center pb-2">لطفا توضیحات تکمیلی خود در مورد نیازتان را برای متخصصان ما یادداشت نمایید، تا بتوانیم به بهترین شکل ممکن درخواست شما را بررسی و پاسخ دهیم.</span>
                    </div>
                    <V8Editor class="mt-3" v-model="data.description"/>
                </div>
                <div class="row justify-content-between py-2 mx-auto">
                    <v-btn :loading="loading" class="submit-btn col-md-1 col-4  mt-5" @click="submit">
                        <span class="fa fa-save mr-1"></span>
                        ثبت سفارش
                    </v-btn>
                    <v-btn class="mx-4 mt-5 btn-refund col-md-1 col-4" @click="step = 4">
                        <span class="fa fa-arrow-right mr-1"></span>
                        بازگشت
                    </v-btn>
                </div>
            </v-stepper-content>

        </v-stepper>
    </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditorUploadAdapterPlugin from "../../../../core/plugins/CKEditorUploadFileAdapter";
import LogoType from "../../components/logoType";
import LangType from "../../components/langType";
import Properties from "../../components/properties";
import SabkType from "../../components/sabkType";
import ColorPickers from "../../components/colorPickers";
import CardType from "../../components/cardType";
import DesignType from "../../components/designType";
import DesignPaint from "../../components/designPaint";
import ComplicativeType from "../../components/complicativeType";
import ShapeType from "../../components/shapeType";
import LogoShape from "../../components/logoShape";
import {createFormData} from "@/Utilities/FormRequestHelper";
import CardSides from "@/view/pages/components/cardSides";
import TracetSabk from "@/view/pages/site/tracet/tracetSabk";

export default {
    name: "tracetStepper",
    components: {
        TracetSabk,
        CardSides,
        LogoShape,
        ShapeType,
        ComplicativeType,
        DesignPaint, DesignType, CardType, ColorPickers, SabkType, Properties, LangType, LogoType
    },
    data() {
        return {
            step: 1,
            days: '',
            marker: true,
            others: true,
            orderType: [
                {text: 'فقط طراحی', value: 'design'},
                {text: 'طراحی به همراه چاپ', value: 'designPrint'},
            ],
            printCount: [
                {text: '۱,۰۰۰ عدد', value: '1000'},
                {text: '۲,۰۰۰ عدد', value: '2000'},
                {text: '۳,۰۰۰ عدد', value: '3000'},
                {text: '۴,۰۰۰ عدد', value: '4000'},
                {text: '۵,۰۰۰ عدد', value: '5000'},
                {text: '۱۰,۰۰۰ عدد', value: '10000'},
            ],
            sizeTracet: [
                {text: 'A5', value: 'A5'},
                {text: 'A6', value: 'A6'},
                {text: 'B5', value: 'B5'},
                {text: 'B6', value: 'B6'},
            ],
            tracetType: [
                {text: ' کاغذگلاسه', value: 'gloss'},
                {text: 'کاغذ سفید', value: 'bw'},
                {text: 'کاغذ رنگی', value: 'colorful'},
            ],
            editor: {
                editor: ClassicEditor,
                editorConfig: {
                    language: 'fa',
                    contentsLangDirection: 'rtl',
                    extraPlugins: [CKEditorUploadAdapterPlugin],
                }
            },
            mainPrice: "",
            dialogPayment: false,
            designs: false,
            payDialogInfo: {},
            payableTransaction: null,
            colorCount: 'one',
            selectedRows: [],
            paymentLoading: false,
            data: {
                organizationName: null,
                brandSlogan: null,
                visitCardType: null,
                headerTexts: null,
                orderType: null,
                backText: null,
                businessDescription: null,
                size: null,
                tarcetType: null,
                designType: null,
                simpleness: null,
                logoShape: null,
                complexity: null,
                printCount: null,
                deliveryTime: null,
                color: [],
                hasBrandSlogan: false,
                slogan: 0,
                preferredCurrency: 'Rial',
                brandName: null,
                logoLanguage: null,
                designStyle: null,
                softness: null,
                user_price: '',
                type: null,
                logoType: null,
                site_type: null,
                file: [],
                brandLogo: [],
                description: '',
            },
            brandSlogan: null,
            orderTypes: [
                {key: 'logo', keyAlias: 'طراحی لوگو', icon: '/media/site/aparat.png'},
                {key: 'visit_card', keyAlias: 'طراحی کارت ویزیت', icon: '/media/site/aparat.png'},
                {key: 'office_set', keyAlias: 'طراحی ست اداری', icon: '/media/site/aparat.png'},
                {key: 'header', keyAlias: 'طراحی سربرگ', icon: '/media/site/aparat.png'},
                {key: 'poster', keyAlias: 'طراحی پوستر', icon: '/media/site/aparat.png'},
                {key: 'office_scan', keyAlias: 'طراحی و چاپ اداری', icon: '/media/site/aparat.png'},
                {key: 'tracet', keyAlias: 'طراحی تراکت', icon: '/media/site/aparat.png'},
            ],
            errors: [],
            dialog: false,
            loading: false,
            rules: [
                v => !!v || 'وارد کردن این فیلد الزامی است'
            ],
            urlRules: [
                (value) => this.isURL(value) || "دامنه سایت باید بصورت https://terminalads.com یا terminalads.com وارد شود. ",
            ],
            errorMsg: '',
            nameErr: '',
            pageTitle: '',
            userWallet: [],
            dialogInfo: null,
            tab: null,
            items: [
                'سفارش ها',
                'ثبت سفارش جدید',
            ],
            userInfo: {},
            statusBadge: '',
            userValid: true,
            isRejected: false,
            isPending: false,
            names: {},
            articleDesc: false,
            enterMine: false,
            userInfoGot: false
        }
    },
    methods: {
        persianName(name, field) {
            this.names[field] = name
        },
        isURL(str) {
            var regex = new RegExp("^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
            var without_regex = new RegExp("^([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
            if (regex.test(str) || without_regex.test(str)) {
                return true
            } else {
                return false;
            }
        },
        paymentDialog(data) {
            this.payDialogInfo = data
            this.dialogPayment = true
        },
        step1Validate() {
            if (!this.data.organizationName || !this.data.brandName) {
                this.$toast.error('نام برند و نام مجموعه الزامی است.')
                return
            } else if (this.data.hasBrandSlogan && !this.data.brandSlogan) {
                this.$toast.error('شعار برند خودرا بنویسید.');
                return
            }else if (this.data.slogan && !this.data.brandSlogan) {
              this.$toast.error('لطفا شعار برند خودرا وارد کنید.')
            } else
            this.step = 2
        },
        step2Validate() {
            if (this.data.type === 'tracet') {
                const tracet = [
                    {main: this.data.logoLanguage, name: 'زبان طراحی '},
                    {main: this.data.color, name: 'رنگ'},
                    {main: this.data.size, name: 'سایز '},
                    {main: this.data.orderType, name: 'نوع سفارش '},
                    {main: this.data.designType, name: 'نوع طرح '},
                ]

                for (let val of tracet) {
                    if (val.main === null || val.main.length <= 0) {
                        this.$toast.error(val.name + ' تراکت ' + ' الزامی است.');
                        return;
                    }
                }
                if (this.data.orderType === 'designPrint' && (!this.data.printCount || !this.data.designStyle)) {
                    this.$toast.error('تعداد چاپ و نوع تراکت خودرا انتخاب کنید.')
                    return
                }
                this.step = 3;
            }
        },
        step3Validate() {
            if (
                this.data.type === 'tracet' && (this.data.brandLogo.length <= 0)
            ) {
                this.$toast.error('لوگوی برند خود را وارد نمایید.')
                return
            }
            this.step = 4
        },
        step4Validate() {
            if ((this.data.type === 'tracet' && this.data.designType === 'oneSide') && (!this.data.headerTexts)) {
                this.$toast.error(' مندرجات روی تراکت را وارد کنید.')
                return;
            } else if ((this.data.type === 'tracet' && this.data.designType === 'twoSide') && (!this.data.headerTexts || !this.data.backText)) {
                this.$toast.error('تمامی مندرجات خواسته شده را وارد کنید.')
                return;
            } else if (
                this.data.type === 'tracet' && (!this.data.deliveryTime || !this.data.businessDescription)
            ) {
                this.$toast.error(' حوزه کسب و کار و زمان تحویل الزامی هستند.')
                return
            }
            this.step = 5
        },
        submit() {
            if ((this.$route.name === 'support.index' && !this.data.description) || (this.$route.name === 'support.index' && !this.data.support_time)) {
                this.$toast.error('تمامی فیلدهای نمایش داده شده اجباری می باشند.');
                return;

            } else {
                this.loading = true
                this.requestApiPost(`form/graphic/tracet`, createFormData(this.data))
                    .then((res) => {
                        if (res.status && res.status === 201) {
                            this.loading = false
                            this.$emit('eventname', 1)
                            this.$toast.success('با موفقیت ثبت شد.');
                        } else {
                            this.$toast.warning('لطفا مجددا تلاش کنید')
                        }
                    })
                    .catch((e) => {
                        this.loading = false
                        this.$toast.error(Object.values(e.response.data.errors).map((x) => {
                            return x.join('\n');
                        }).join(''));

                        this.errors = e.response.data.errors
                    })
                    .finally(() => {
                        this.loading = false;
                        this.$modal.hideLoading();
                    })
            }
        },
        pay(transactionId) {
            if (this.payDialogInfo.payments.type === 'final') {

                this.requestApiPost(`payment/${this.payDialogInfo.id}/pay`, {transaction_id: this.payDialogInfo.payments.transactions[0].id})
                    .then(response => {
                        this.$toast.success('با موفقیت پرداخت شد!')
                        this.getSites()
                        this.dialogPayment = false
                    }).catch(({res}) => {
                    this.loading = false
                    this.$toast.error(res.data.message)
                })


            } else {
                this.requestApiPost(`payment/${this.payDialogInfo.id}/pay`, {transaction_id: transactionId})
                    .then(response => {
                        this.$toast.success('با موفقیت پرداخت شد!')
                        this.getSites()
                        this.dialogPayment = false
                    }).catch(({res}) => {
                    this.loading = false
                    this.$toast.error(res.data.message)
                })

            }
        },
        getSites(url = this.url, params = this.tableProps) {
            this.$modal.showLoading();
            this.requestApiGet(url, params).then(response => {
                this.userInfo = response.data;
            }).finally(() => {
                this.$modal.hideLoading();
                if (!this.userInfoGot) {
                    this.getUserInfo();
                }
            })
        },
        edit(data) {
            this.$router.push({name: 'admin.user.edit', params: {id: data.id}})
        },
        information(data) {
            this.$router.push({name: 'admin.users.information', params: {id: data.id}})
        },
        checkRoutes() {
            if (this.$route.name === 'tracet.index') {
                this.data.type = 'tracet';
                this.pageTitle = this.orderTypes[6].keyAlias
            }
        },
        changeUnit() {
            this.marker = !this.marker;
            if (this.marker) {
                this.data.preferredCurrency = 'Rial'
            } else this.data.preferredCurrency = 'Toman'
        }
    },
    watch: {
        'data.organozationName': function (value) {
            var regex = /^[a-zA-Z]+$/;
            if (value > 3 && !value.match(regex)) {
                this.nameErr = 'نام مجموعه نمیتواند تنها شامل اعداد باشد.'
            } else
                this.nameErr = '';
        },
        'data.hasBrandSlogan': function (value) {
            if (value) {
                this.data.brandSlogan = this.brandSlogan;
            } else this.data.brandSlogan = null
        },
        colorCount(value) {
            if (value === 'bw') {
                this.data.color = ['#FFFFFF', '#000000']
            }
        },
        'data.slogan': function (value) {
            if (value) {
                this.data.slogan = 1
            } else this.data.slogan = 0
        }
    },
    computed: {
        main_price: {
            get() {
                return this.$options.filters.currency(this.data.user_price)
            },
            set(value) {
                this.data.user_price = value.replaceAll(',', '')
            }
        },
        countDay: {
            get() {
                const minimum_day = new Date();
                minimum_day.setDate(minimum_day.getDate() + 5);
                return minimum_day;
            },
            set(value) {
            }
        },
        printCounting: {
            set(value) {
                this.data.printCount = value * 1000;
            },
        },
    },
    mounted() {
        this.checkRoutes();
    }
}
</script>

<style scoped>

</style>